import clx from 'classnames';
import AvatarLabel, { AvatarLabelProps } from '@/atoms/AvatarLabel';
import Link from 'next/link';

export type UserLinkProps = AvatarLabelProps & {
  userUniqId: string;
  className?: string;
};
const UserLink = ({ userUniqId, className, ...avatarLabelProps }: UserLinkProps) => (
  <Link className={clx(className, 'bg-neutral-50 rounded-full block p-1')} href={`/profile/${userUniqId}`}>
    <AvatarLabel {...avatarLabelProps} />
  </Link>
);
export default UserLink;
